import React from 'react'
import PropTypes from 'prop-types'
import {useIncrementingId} from '#hooks/useIncrementingId'

function Checkbox({labelText, value, checked, onChangeHandle, disabledState}) {
  const id = useIncrementingId()

  let modifier = checked ? 'checkbox--checked' : ''
  if (disabledState) {
    modifier += ' checkbox--disabled'
  }
  const hasEvent = onChangeHandle && !disabledState
  return (
    <div className={modifier ? `checkbox ${modifier}` : 'checkbox'}>
      <label htmlFor={id}>
        <div className="checkbox__indicator" />
        <input
          id={id}
          disabled={disabledState}
          type="checkbox"
          value={value}
          checked={checked}
          onChange={hasEvent ? elem => onChangeHandle(elem) : undefined}
        />
        {labelText}
      </label>
    </div>
  )
}

Checkbox.propTypes = {
  labelText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  value: PropTypes.string,
  checked: PropTypes.bool,
  onChangeHandle: PropTypes.func,
  disabledState: PropTypes.bool,
}

export default Checkbox
